<template>
  <div class="form">
    <slot name="heading"/>

    <form @submit.prevent="$emit('submit', $event)">
      <slot name="form-heading"/>
      <slot/>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'WForm',
  };
</script>

<style scoped lang="scss">
  @import "../assets/styles/variables";

  .form {
    width: 100%;
    margin: 0 auto;
    @media(max-width: 575px) {
      width: 100%;
    }
    .text-field {
      padding: 12px 0;

      font-family: 'Roboto';
      font-size: 14px;
      margin: 0 auto;
    }

    .button {
      font-family: 'Roboto';
      font-size: 14px;
      line-height: 16px;
      margin: 28px auto 12px;
      display: block;
    }

    .link {
      display: block;
      width: 100%;
      text-align: center;
      color: $primary-dark;
      font-weight: 800;
    }
  }

  h3 {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 44px;
    text-align: center;
    color: #02CAF2;
    padding: 32px 0 28px;
    margin: 0;
    @media (max-width: 996px) {
      font-size: 24px !important;
      line-height: 28px;
    }
  }

  h4 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    width: 392px;
    padding: 12px 0;
    margin: 0 auto;
    @media (max-width: 996px) {
      margin: 0;
      width: 100%;
    }
  }
</style>
